(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alto-benefits-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) return;

    const updateAppLinks = () => {
      document.querySelectorAll('[data-alto-app-ios]').forEach((link) => {
        link.href = link.dataset.altoAppIos;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAppLinks, { once: true });
    } else {
      updateAppLinks();
    }
    document.addEventListener('shopify:section:load', updateAppLinks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-vip-black-revelada"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alto-vip-black')) {
    customElements.define('alto-vip-black', class extends HTMLElement {
      connectedCallback() {
        this.updateLinks = () => {
          const incoming = new URL(window.location.href).searchParams;
          const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'fbclid', 'ttclid', 'sck'];
          this.querySelectorAll('[data-vip-cta]').forEach(link => {
            const destination = new URL(link.dataset.vipUrl, window.location.origin);
            keys.forEach(key => {
              if (incoming.has(key) && !destination.searchParams.has(key)) destination.searchParams.set(key, incoming.get(key));
            });
            link.href = destination.href;
          });
        };
        this.updateLinks();
        this.addEventListener('click', this.updateLinks);
        const clock = this.querySelector('[data-vip-countdown]');
        const rawEnd = this.dataset.countdownEnd || '';
        const resetDaily = this.dataset.countdownDaily === 'true';
        const end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(rawEnd) ? Date.parse(rawEnd) : NaN;
        const dailyClock = resetDaily ? new Intl.DateTimeFormat('en-GB', {timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'}) : null;
        const getRemaining = () => {
          if (resetDaily) {
            const parts = dailyClock.formatToParts(new Date());
            const time = unit => Number(parts.find(part => part.type === unit).value);
            return 86399 - (time('hour') * 3600 + time('minute') * 60 + time('second'));
          }
          return Math.max(0, Math.floor((end - Date.now()) / 1000));
        };
        if (!clock || (!resetDaily && (!Number.isFinite(end) || end <= Date.now()))) return;
        const tick = () => {
          const remaining = getRemaining();
          clock.hidden = !resetDaily && remaining === 0;
          if (!resetDaily && !remaining) { clearInterval(this.timer); return; }
          const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
          Object.entries(values).forEach(([key, value]) => {
            this.querySelector('[data-vip-time="' + key + '"]').textContent = String(value).padStart(2, '0');
          });
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.removeEventListener('click', this.updateLinks);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-vip-invite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alto-vip-invite')) {
    customElements.define('alto-vip-invite', class extends HTMLElement {
      connectedCallback() {
        this.updateLinks = () => {
          const incoming = new URL(window.location.href).searchParams;
          const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'fbclid', 'ttclid', 'sck'];
          this.querySelectorAll('[data-vip-cta]').forEach(link => {
            const destination = new URL(link.dataset.vipUrl, window.location.origin);
            keys.forEach(key => {
              if (incoming.has(key) && !destination.searchParams.has(key)) {
                destination.searchParams.set(key, incoming.get(key));
              }
            });
            link.href = destination.href;
          });
        };
        this.updateLinks();
        this.addEventListener('click', this.updateLinks);

        const clock = this.querySelector('[data-vip-countdown]');
        const rawEnd = this.dataset.countdownEnd || '';
        const resetDaily = this.dataset.countdownDaily === 'true';
        const fixedEnd = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(rawEnd) ? Date.parse(rawEnd) : NaN;
        const dailyClock = resetDaily ? new Intl.DateTimeFormat('en-GB', {
          timeZone: 'America/Recife', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        }) : null;
        const getRemaining = () => {
          if (resetDaily) {
            const parts = dailyClock.formatToParts(new Date());
            const time = unit => Number(parts.find(part => part.type === unit).value);
            return 86399 - (time('hour') * 3600 + time('minute') * 60 + time('second'));
          }

          return Math.max(0, Math.floor((fixedEnd - Date.now()) / 1000));
        };
        if (!clock || (!resetDaily && (!Number.isFinite(fixedEnd) || fixedEnd <= Date.now()))) return;
        const tick = () => {
          const remaining = getRemaining();
          clock.hidden = !resetDaily && remaining === 0;
          if (!resetDaily && !remaining) {
            clearInterval(this.timer);
            return;
          }
          const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
          Object.entries(values).forEach(([key, value]) => {
            this.querySelector(`[data-vip-time="${key}"]`).textContent = String(value).padStart(2, '0');
          });
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.removeEventListener('click', this.updateLinks);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-slide"] && !Shopify.designMode) return;
  try {
    
class TdShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    const initSlider = () => {
      if (this.slider || typeof window.Swiper !== 'function') return

      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      const initialVideo = this.slider.slides?.[this.slider.activeIndex]?.querySelector('video[data-autoplay="true"]')
      if (initialVideo) {
        initialVideo.muted = false
        initialVideo.autoplay = true
        initialVideo.closest('.td-shoppable-videos-card')?.setAttribute('data-is-playing', 'true')
        initialVideo.play().catch(() => {})
      }

      this.slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
        this.updateSlideScale()
      })

      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
        this.updateSlideScale()

        const activeSlideVideo = this.slider.slides?.[this.slider.activeIndex]?.querySelector('video[data-autoplay="true"]')
        if (activeSlideVideo) {
          const activeCard = activeSlideVideo.closest('.td-shoppable-videos-card')
          activeCard?.setAttribute('data-is-playing', 'true')
          activeSlideVideo.muted = false
          activeSlideVideo.autoplay = true
          activeSlideVideo.play().catch(() => {})
        }
      })

      this.slider.on('progress', () => {
        this.updateSlideScale()
      })

      this.updateSlideScale()
    }

    let script = document.querySelector('#swiper-script')

    if (!script) {
      script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      script.addEventListener('load', initSlider)
      document.head.appendChild(script)
    } else if (typeof window.Swiper === 'function') {
      initSlider()
    } else {
      script.addEventListener('load', initSlider)
    }

    this.querySelectorAll('.td-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.td-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target
          video.muted = true
          video.autoplay = true
          video.play().catch(() => {})
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      loop: true,
      centeredSlides: true,
      spaceBetween: 20,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000, disableOnInteraction: false }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  updateSlideScale () {
    if (!this.slider) return
    
    const slides = this.slider.slides
    
    slides.forEach((slide) => {
      const slideEl = slide
      const progress = slide.progress || 0
      const distance = Math.abs(progress)
      
      // Remove classes anteriores
      slideEl.classList.remove('swiper-slide-scale-active', 'swiper-slide-scale-next')
      
      if (distance < 0.15) {
        // Slide ativo (centro)
        slideEl.classList.add('swiper-slide-scale-active')
      } else if (distance < 1.2) {
        // Slides próximos (next e prev)
        slideEl.classList.add('swiper-slide-scale-next')
      }
    })
  }

  onSlideChange () {
    this.querySelectorAll('.td-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.td-shoppable-videos-card')

    this.querySelectorAll('.td-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('td-shoppable-videos', TdShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
